import { Component } from 'react'
import {Router,Route,Switch} from 'react-router-dom';
import { createBrowserHistory } from "history";
import ShoppingCart from '../components/index';

const history = createBrowserHistory();

// let ShoppingCart = '';
// ShoppingCart = loadable(()=>import('../components/index'));

class App extends Component {

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route exact path="/expresscart/list" component={ShoppingCart} />
                </Switch>
            </Router>
        )
    }
}

export default App
